import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Img1 from 'assets/Home/portfolio/chain1.avif'
import Img2 from 'assets/Home/portfolio/chain2.avif'

const ColdChain = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Main Page
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    검증된 의약품의 안전배송{!isTablet && <br />}
                    온도, 습도 등 환경 조건을 사용자가{!isTablet && <br />}
                    실시간으로 모니터링 및 직접 추적합니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    사용자는 운송 서비스를 통해 자신의 배송일정을{!isTablet && <br />}
                    확인하고 추적할 수 있습니다. 배송중인 의약품의 상태를{!isTablet && <br />}
                    실시간으로 모니터링하여 즉가적인 대응을 할 수 있습니다
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Delivery Tracking Service
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    IoT 기기 연동을 통해 운송 중 문제나{!isTablet && <br />}
                    환경 변화에 즉각적인 대응 알림을 받고{!isTablet && <br />}
                    민감한 제품에 대한 안전 배송이 가능합니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    소비자와 운송 기사 간 월활한 소통을 지원하며,{!isTablet && <br />}
                    운송 과정에서 투명성과 효율성을 높이고 상호간 신뢰를 높힙니다.
                </motion.h4>

                <motion.img
                    src={Img2}
                    alt="Img2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default ColdChain
